import React from 'react';
import * as IconFactory from 'app/components/common/IconFactory.jsx';


const SupportedNetworks = (props) => {
    let icons = [
        'facebook',
        'x',
        'bluesky',
        'instagrambusiness',
        'linkedin',
        'pinterest',
        'gmb',
        'threads',
        'tiktok',
        'youtube',
        'mastodon',
        'wordpress',
        'blogger',
        'tumblr',
        'discord',
        'slack',
        'nextdoor',
        'snapchat',
        'stocktwits',
        'feed'
    ];
    return (
        <div className="supported-socials clearfix">
            <h1>Share to {icons.length} Social Platforms</h1>
            <ul className="supported-social-list clearfix">
                {icons.map((icon) => {
                    let Icon = IconFactory[icon];
                    return (
                        <li key={`icon-${icon}`}>
                            <Icon large={true} mono={true} alt="round rollover"/>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SupportedNetworks;
